module.exports = __webpack_public_path__ + "img/clipboard.9238e2ee.svg";